import { render, staticRenderFns } from "./PersonProfileRecentNotesOverview.vue?vue&type=template&id=f465ff8e&scoped=true&"
import script from "./PersonProfileRecentNotesOverview.vue?vue&type=script&lang=js&"
export * from "./PersonProfileRecentNotesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f465ff8e",
  null
  
)

export default component.exports